import { useQuery } from '@tanstack/react-query';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '@/services/firebase';
import { converter } from '@/lib/firestore-converters';
import { pressArticles as seedData } from '@/data';
import type { PressArticle } from '@/types';

const USE_SEED = import.meta.env.VITE_USE_SEED_DATA === 'true';

export function usePressArticles() {
  return useQuery({
    queryKey: ['press-articles'],
    queryFn: async (): Promise<PressArticle[]> => {
      if (USE_SEED) {
        return seedData.filter(a => a.active).sort((a, b) => a.order - b.order);
      }
      // Sort client-side — avoids requiring a composite index on (active, order).
      const col = collection(db, 'pressArticles').withConverter(converter<PressArticle>());
      const q = query(col, where('active', '==', true));
      const docs = (await getDocs(q)).docs.map(d => d.data());
      return docs.sort((a, b) => (a.order ?? 99) - (b.order ?? 99));
    },
    staleTime: 60 * 60_000,
  });
}
